module.exports = __webpack_public_path__ + "media/country_flags/ax-d43f78a7.png";